<template>
  <div class="pagingModule">
    <div class="pagingTotal" v-if="totalStatus">
      <p>
        共 <span>{{ total }}</span> {{ totalInfo || '条' }}
      </p>
    </div>
    <el-pagination
      v-if="total > 0"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      style="display: inline-block"
      :current-page.sync="pageCurrentComputed"
      :page-size="pageSize"
      prev-text="上一页"
      next-text="下一页"
      :page-sizes="[1, 10, 20, 50, 100]"
      :layout="layout || 'sizes,prev, pager, next'"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    // 总数
    total: {
      type: Number,
      default: 0
    },
    totalStatus: {
      type: Boolean,
      default: false
    },
    totalInfo: {
      type: String,
      default: ''
    },
    // 当前页
    pageCurrent: {
      type: Number | String,
      default: '-1'
    },
    // 分页码
    pageSize: {
      type: Number,
      default: 10
    },
    layout: {
      type: String,
      default: 'sizes,prev, pager, next'
    }
  },
  computed: {
    pageCurrentComputed: {
      set(val) {},
      get() {
        return this.pageCurrent;
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val);
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/module/paginationEL/index.vue